import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { contentHeaders } from 'common/headers';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Config } from '../config/env.config';
import { Observable } from 'rxjs';


@Injectable()
export class AuthService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private jwtHelperService: JwtHelperService,
  ) {}

  authenticate(email: string, password: string): Observable<any> {
    const body = JSON.stringify({email, password});
    return this.http.post(Config.API + '/authenticate', body, {headers: contentHeaders});
  }

  register(email: string, password: string, name: string): Observable<any> {
    const body = JSON.stringify({email, password, name});
    return this.http.post(Config.API + '/register', body, {headers: contentHeaders});
  }

  loggedIn() {
    if (this.jwtHelperService.isTokenExpired()) {
      this.router.navigate(['login']);
      return false;
    } else {
      return true;
    }
  }

  logout() {
    localStorage.removeItem(Config.AUTH_TOKEN);
    this.router.navigate(['login']);
  }

  token() {
    return localStorage.getItem(Config.AUTH_TOKEN);
  }

  saveToken(token: string) {
    localStorage.setItem(Config.AUTH_TOKEN, token);
  }

}
